import styles from './index.less';
import $ from 'jquery';

const defaultPrams = {
  text: '',
  isSelect: 0,
  auther: '',
  view: 0,
};
export default class TextInfo {
  constructor(props) {
    this.wrapper = props.wrapper;
    this.params = {
      ...defaultPrams,
      ...props,
    };
    this._init();
  }
  _init() {
    this._initContent();
    this._autoHide();
  }
  _initContent() {
    const params = this.params;
    //添加标题标签
    this.$content = $(`<div class="${styles['text-wrapper']}"></div>`);
    if (params.isSelect && params.isSelect != '0') {
      this.$content.append(`<p class="${styles.tag}">精品</p>`);
    }
    this.$content.append(`<p class="${styles.text}">${params.text}</p>`);
    $(this.wrapper).append(this.$content);

    //添加作者 人气
    // $(this.wrapper).append(`<div class="${styles.info}">
    //   <span>作者： ${params.auther}</span>
    //   <span>人气： ${this._getDisplayView(params.view)}</span>
    // </div>`);
  }
  _autoHide() {
    setTimeout(() => {
      this.$content.fadeOut();
    }, 8000);
  }
  _getDisplayView(value) {
    return value;
  }
}
